import React from "react";

export default function CartItemContainer({ children }) {
  return (
    <div
      style={{
        height: "90%"
      }}
      className="w-full overflow-y-scroll"
    >
      {children}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/CartItemContainer/CartItemContainer.js